export const REQUEST_DICTIONARY = 'REQUEST_DICTIONARY';
export const FILE_VALIDATER = 'FILE_VALIDATER';
export const GET_JOB_STATUS_DETAILS = 'GET_JOB_STATUS_DETAILS';
//export const GET_JOB_DETAILS_INFO = 'GET_JOB_DETAILS_INFO';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOG_OUT = 'LOG_OUT';

export const GET_JOB_DETAILS_REQUEST = 'GET_JOB_DETAILS_REQUEST';
export const GET_JOB_DETAILS_SUCCESS = 'GET_JOB_DETAILS_SUCCESS';
export const GET_JOB_DETAILS_FAILURE = 'GET_JOB_DETAILS_FAILURE';

export const UPDATE_BREADCRUMB = 'UPDATE_BREADCRUMB';

export const GET_ASSET_TYPE_REQUEST = 'GET_JOB_DETAILS_REQUEST';
export const GET_ASSET_TYPE_SUCCESS = 'GET_JOB_DETAILS_SUCCESS';
export const GET_ASSET_TYPE_FAILURE = 'GET_JOB_DETAILS_FAILURE';

export const GET_WEB_INFO_REQUEST = 'GET_WEB_INFO_REQUEST';
export const GET_WEB_INFO_SUCCESS = 'GET_WEB_INFO_SUCCESS';
export const GET_WEB_INFO_FAILURE = 'GET_WEB_INFO_FAILURE';

export const GET_PUBMED_ID_SEARCH_REQUEST = 'GET_PUBMED_ID_SEARCH_REQUEST';
export const GET_PUBMED_ID_SEARCH_SUCCESS = 'GET_PUBMED_ID_SEARCH_SUCCESS';
export const GET_PUBMED_ID_SEARCH_FAILURE = 'GET_PUBMED_ID_SEARCH_FAILURE';
export const CLEAR_PUBMED_ID_DETAILS = 'CLEAR_PUBMED_ID_DETAILS';

export const PRODUCT_IDENTIFIERS_VALIDATE_REQUEST = 'PRODUCT_IDENTIFIERS_VALIDATE_REQUEST';
export const PRODUCT_IDENTIFIERS_VALIDATE_SUCCESS = 'PRODUCT_IDENTIFIERS_VALIDATE_SUCCESS';
export const PRODUCT_IDENTIFIERS_VALIDATE_FAILURE = 'PRODUCT_IDENTIFIERS_VALIDATE_FAILURE';
export const CLEAR_PRODUCT_IDENTIFIERS_VALIDATE = 'CLEAR_PRODUCT_IDENTIFIERS_VALIDATE';

export const GET_UNLEASHDETAILS_REQUEST = 'GET_UNLEASHDETAILS_REQUEST';
export const GET_UNLEASHDETAILS_SUCCESS = 'GET_UNLEASHDETAILS_SUCCESS';
export const GET_UNLEASHDETAILS_FAILURE = 'GET_UNLEASHDETAILS_FAILURE';

export const GET_RECENT_REQUEST = 'GET_RECENT_REQUEST';
export const GET_RECENT_SUCCESS = 'GET_RECENT_SUCCESS';
export const GET_RECENT_FAILURE = 'GET_RECENT_FAILURE';

export const GET_JOBS_REQUEST= 'GET_JOBS_REQUEST';
export const GET_JOBS_SUCCESS= 'GET_JOBS_SUCCESS';
export const GET_JOBS_FAILURE= 'GET_JOBS_FAILURE';

export const SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS = 'SINGLE_UPLOAD_PAYLOAD_UPDATE_SUCCESS';
export const GET_JOB_DETAIL_REQUEST= 'GET_JOB_DETAIL_REQUEST';
export const GET_JOB_DETAIL_SUCCESS= 'GET_JOB_DETAIL_SUCCESS';
export const GET_JOB_DETAIL_FAILURE= 'GET_JOB_DETAIL_FAILURE';
export const CLEAR_JOB_DETAIL= 'CLEAR_JOB_DETAIL';

export const GET_ASSET_TYPES_REQUEST= 'GET_ASSET_TYPES_REQUEST';
export const GET_ASSET_TYPES_SUCCESS= 'GET_ASSET_TYPES_SUCCESS';
export const GET_ASSET_TYPES_FAILURE= 'GET_ASSET_TYPES_FAILURE';

export const SINGLE_UPLOAD_PAYLOAD_CLEAR = 'SINGLE_UPLOAD_PAYLOAD_CLEAR';
export const GET_SIMPLE_SEARCH_REQUEST = 'GET_SIMPLE_SEARCH_REQUEST';
export const GET_SIMPLE_SEARCH_SUCCESS = 'GET_SIMPLE_SEARCH_SUCCESS';
export const GET_SIMPLE_SEARCH_FAILURE = 'GET_SIMPLE_SEARCH_FAILURE';

export const GET_ADVANCED_SEARCH_REQUEST = 'GET_ADVANCED_SEARCH_REQUEST';
export const GET_ADVANCED_SEARCH_SUCCESS = 'GET_ADVANCED_SEARCH_SUCCESS';
export const GET_ADVANCED_SEARCH_FAILURE = 'GET_ADVANCED_SEARCH_FAILURE';

export const SEARCH_KEYWORD_UPDATE_SUCCESS = 'SEARCH_KEYWORD_UPDATE_SUCCESS';

export const GET_INPUT_VALIDATION_ONBLUR = 'GET_INPUT_VALIDATION_ONBLUR';
export const GET_INPUT_VALIDATION_CLEAR = 'GET_INPUT_VALIDATION_CLEAR';
export const GET_INPUT_VALIDATION_ON_SUBMIT = 'GET_INPUT_VALIDATION_ON_SUBMIT';

export const GET_USER_TYPE_REQUEST = 'GET_USER_TYPE_REQUEST';
export const GET_USER_TYPE_SUCCESS = 'GET_USER_TYPE_SUCCESS';
export const GET_USER_TYPE_FAILURE = 'GET_USER_TYPE_FAILURE';
export const GET_INPUT_VALIDATION_ON_SUBMIT_CLEAR = 'GET_INPUT_VALIDATION_ON_SUBMIT_CLEAR';

export const DROPDOWN_OPTIONS_UPDATE = 'DROPDOWN_OPTIONS_UPDATE';
export const DROPDOWN_OPTIONS_RESET = 'DROPDOWN_OPTIONS_RESET';

export const GET_TARGETSITE_ERP_MAPPING_REQUEST = 'GET_TARGETSITE_ERP_MAPPING_REQUEST';
export const GET_TARGETSITE_ERP_MAPPING_SUCCESS = 'GET_TARGETSITE_ERP_MAPPING_SUCCESS';
export const GET_TARGETSITE_ERP_MAPPING_FAILURE = 'GET_TARGETSITE_ERP_MAPPING_FAILURE';

export const GET_CASCADE_DROPDOWN_VALUES_REQUEST = 'GET_CASCADE_DROPDOWN_VALUES_REQUEST';
export const GET_CASCADE_DROPDOWN_VALUES_SUCCESS = 'GET_CASCADE_DROPDOWN_VALUES_SUCCESS';
export const GET_CASCADE_DROPDOWN_VALUES_FAILURE = 'GET_CASCADE_DROPDOWN_VALUES_FAILURE';

export const CASCADE_DROPDOWN_OPTIONS_SUCCESS = 'CASCADE_DROPDOWN_OPTIONS_SUCCESS';